import styled from 'styled-components'

export const Image = styled.img`
  position: absolute;
  width: 20%;
  right: -${p => p.theme.indents.baseIndentXs};
  bottom: 0;
  z-index: 2;

  ${p => p.theme.mq.upMd} {
    right: -${p => p.theme.indents.baseBoxIndentLg};
  }
`
